module.exports = __webpack_public_path__ + "img/solution4.1125aa92.png";